// extracted by mini-css-extract-plugin
export default {"loading":"styles-loading-bf2cd3"};